import {
  CRASH_LIST_VIEW,
  buildCrashListViewQueryParams,
} from '../../pages/Statistics/statistics-dataset-context';
import {
  appendCrashListQueryParams,
  appendCrashListSortParams,
  resolveCrashListQueryFilters,
} from '../../utils/crash-list-pagination';

export function buildValidatedSourceRowsUrl({
  baseUrl,
  masterCrashId,
  panelFilters,
  filterModel,
  configuration,
  sortModel,
  datasetFilter,
  lockDatasetToMerged,
  user,
}) {
  const url = new URL(baseUrl);
  url.searchParams.set('format', 'table');
  url.searchParams.set('matchMasterId', masterCrashId);

  const datasetParams = buildCrashListViewQueryParams({
    view: CRASH_LIST_VIEW.SOURCE,
    datasetFilter,
    lockDatasetToMerged,
    user,
  });
  appendCrashListQueryParams(url, {
    datasetParams,
    filters: resolveCrashListQueryFilters(panelFilters, filterModel, configuration),
  });

  appendCrashListSortParams(url, sortModel, configuration);
  return url;
}
